var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M24,19.895c0,2.209-1.791,4-4,4H4.029c-2.209,0-4-1.791-4-4V4.083c0-2.209,1.791-4,4-4H20 c2.209,0,4,1.791,4,4V19.895z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#070707",
    cx: 6.086,
    cy: 11.792,
    r: 2.177
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#070707",
    cx: 11.803,
    cy: 11.792,
    r: 2.177
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#070707",
    cx: 17.942,
    cy: 11.792,
    r: 2.176
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.a1594fbd8f37e17aef80d9f267c6e081.svg";
export { ForwardRef as ReactComponent };